import { UserRole } from "~/types/user";

// Helper function to determine page title based on the current path
export const getPageTitle = (path: string): string => {
  switch (true) {
    case path === "/clients":
      return "Clientes";
    case path.startsWith("/clients/"):
      return "Detalle de Cliente";
    case path === "/client-approvals":
      return "Aprobación de Clientes";
    case path === "/sales-notes": {
      // Different title based on the user role
      const userRole = localStorage.getItem("userRole") as UserRole;
      return userRole === "logistica" ? "Envíos Pendientes" : "Notas de Venta";
    }
    case path === "/despachos":
      return "Envíos";
    case path === "/facturas":
      return "Facturas";
    case path === "/facturas/visualizar":
      return "Facturas - Visualizar";
    case path === "/facturas/cuentas-por-cobrar":
      return "Cuentas por Cobrar";
    case path === "/facturas/bsale":
      return "Notas de Crédito y Facturas BSALE";
    case path === "/payment-requests":
      return "Solicitudes de Pago";
    case path === "/payment-dashboard":
      return "Panel de Pagos";
    case path === "/admin-settings":
      return "Administración de Usuarios";
    case path === "/payments-overview":
      return "Panel de Pagos";
    case path === "/payments-summary":
      return "Resumen de Pagos";
    case path === "/late-payments":
      return "Pagos Atrasados";
    case path === "/unidentified-payments":
      return "Pagos No Identificados";
    case path === "/manual-payments":
      return "Registrar Pago Manual";
    case path === "/cheques":
      return "Gestión de Cheques";
    case path === "/products":
      return "Productos";
    case path === "/client-risk-management":
      return "Gestión de Riesgo de Clientes";
    case path === "/commercial-team":
      return "Equipo Comercial";
    case path === "/vendedores":
      return "Vendedores";
    case path.startsWith("/seller/"):
      return "Detalle de Vendedor";
    case path === "/sales-conditions":
      return "Condiciones de Venta";
    case path === "/deudas":
      return "Deudas";
    case path === "/debt-reminders":
      return "Recordatorios de Deuda";
    case path === "/test-credit-notes":
      return "Pruebas de Notas de Crédito BSale";
    case path === "/monthly-snapshots":
      return "Snapshots Mensuales";
    case path === "/facturas/analisis-periodos":
      return "Análisis Cross-Period";
    case path === "/metas-de-venta":
      return "Metas de Venta";
    case path === "/cotizaciones":
      return "Cotizaciones";
    case path.startsWith("/cotizaciones/"):
      return "Detalle de Cotización";
    case path === "/daily-debt-snapshots":
      return "Historial de Deuda";
    case path.startsWith("/daily-debt-snapshots/client/"):
      return "Historial de Deuda - Cliente";
    // Contabilidad routes
    case path === "/contabilidad/empresas":
      return "Empresas Contables";
    case path.startsWith("/contabilidad/empresas/"):
      return "Detalle de Empresa";
    case path === "/contabilidad/diarios":
      return "Diarios Contables";
    case path.startsWith("/contabilidad/diarios/"):
      return "Detalle de Diario";
    case path === "/contabilidad/cuentas":
      return "Plan de Cuentas";
    case path.startsWith("/contabilidad/cuentas/"):
      return "Detalle de Cuenta";
    case path === "/contabilidad/movimientos":
      return "Movimientos Contables";
    case path.startsWith("/contabilidad/movimientos/"):
      return "Detalle de Movimiento";
    case path === "/contabilidad/proveedores":
      return "Proveedores";
    case path.startsWith("/contabilidad/proveedores/"):
      return "Estado de Cuenta del Proveedor";
    case path === "/contabilidad/facturas-proveedor":
      return "Facturas de Proveedor";
    case path === "/contabilidad/pagos-proveedor":
      return "Pagos a Proveedor";
    // Purchasing routes
    case path === "/purchasing/orders":
      return "Órdenes de Compra";
    case path === "/purchasing/orders/new":
      return "Nueva Orden de Compra";
    case path.startsWith("/purchasing/orders/"):
      return "Detalle de Orden de Compra";
    case path === "/purchasing/compras/proveedores":
      return "Proveedores";
    case path.startsWith("/purchasing/compras/proveedores/"):
      return "Proveedor — Órdenes de Compra";
    case path === "/purchasing/stock":
      return "Stock de Ingredientes";
    case path === "/purchasing/traslados":
      return "Traslados de Ingredientes";
    case path === "/purchasing/ajustes-ingredientes":
      return "Ajustes de Inventario";
    case path === "/costeo/variacion-inventario":
      return "Variación Real vs Teórico";
    // Exchange rates
    case path === "/exchange-rates":
      return "Tipos de Cambio";
    // Production routes
    case path === "/production/recipes":
      return "Recetas de Producción";
    case path === "/production/batches":
      return "Lotes de Producción";
    case path === "/production/batches/new":
      return "Nuevo Lote de Producción";
    case path.startsWith("/production/batches/"):
      return "Detalle de Lote";
    case path === "/production/consumo-por-sku":
      return "Consumo por SKU";
    case path === "/production/mermas":
      return "Mermas";
    // WMS routes
    case path === "/wms":
      return "Bodega";
    case path === "/wms/locations":
      return "Bodegas";
    case path.startsWith("/wms/locations/"):
      return "Detalle de Bodega";
    case path === "/wms/ubicaciones":
      return "Todas las Ubicaciones";
    case path === "/wms/inventory":
      return "Inventario de Bodega";
    case path === "/wms/relocation":
      return "Reubicacion";
    case path === "/wms/movements":
      return "Historial de Movimientos";
    case path === "/wms/consolidated-stock":
      return "Stock Consolidado";
    // New parallel inventory module (beta)
    case path === "/inventario/stock":
      return "Inventario — Stock";
    case path === "/inventario/operaciones":
      return "Inventario — Operaciones";
    case path === "/inventario/aprobaciones":
      return "Inventario — Aprobaciones";
    case path === "/inventario/kardex":
      return "Inventario — Historial de movimientos";
    case path === "/inventario/productos":
      return "Inventario — Productos";
    case path === "/inventario/productos/:id":
      return "Inventario — Detalle de Producto";
    // Totem routes
    case path === "/totems":
      return "Gestión de Totems";
    case path.startsWith("/totems/"):
      return "Detalle de Totem";
    default:
      return "Dashboard";
  }
};

// Helper function to check if user has access to a route
export const hasAccessToRoute = (path: string, userRole: UserRole): boolean => {
  if (path === "/") return true;

  // External fiscal advisor: read-only access limited to accounting reports.
  if (userRole === "asesor-fiscal") {
    return path.startsWith("/contabilidad/reportes");
  }

  if (path === "/despachos") {
    return userRole === "logistica" || userRole === "superadmin";
  }

  if (
    path === "/payments-summary" ||
    path === "/late-payments" ||
    path === "/unidentified-payments" ||
    path === "/manual-payments" ||
    path === "/cheques"
  ) {
    return (
      userRole === "cobranza" ||
      userRole === "facturacion" ||
      userRole === "superadmin"
    );
  }

  if (
    path === "/facturas" ||
    path === "/facturas/visualizar" ||
    path === "/facturas/cuentas-por-cobrar" ||
    path === "/facturas/bsale"
  ) {
    return (
      userRole === "cobranza" ||
      userRole === "facturacion" ||
      userRole === "seller" ||
      userRole === "superadmin"
    );
  }

  if (path.startsWith("/payment")) {
    return userRole === "cobranza" || userRole === "superadmin";
  }

  if (path === "/client-approvals") {
    return userRole === "superadmin" || userRole === "admin";
  }

  if (path.startsWith("/client")) {
    return (
      userRole === "seller" ||
      userRole === "superadmin" ||
      userRole === "risk" ||
      userRole === "facturacion" ||
      userRole === "cobranza"
    );
  }

  if (path === "/sales-notes") {
    return true; // Allow all authenticated users to access sales-notes
  }

  if (path === "/admin-settings" || path === "/products") {
    return (
      userRole === "superadmin" ||
      (path === "/admin-settings" && userRole === "admin")
    );
  }

  if (path === "/client-risk-management") {
    return userRole === "risk" || userRole === "superadmin";
  }

  if (path === "/commercial-team") {
    return userRole === "risk" || userRole === "superadmin";
  }

  if (path === "/vendedores" || path.startsWith("/seller/")) {
    return userRole === "superadmin";
  }

  if (path === "/sales-conditions") {
    return userRole === "superadmin";
  }

  if (path === "/test-credit-notes") {
    return userRole === "superadmin";
  }

  if (path === "/monthly-snapshots") {
    return userRole === "superadmin" || userRole === "admin";
  }

  if (path === "/deudas") {
    return userRole === "superadmin" || userRole === "facturacion";
  }

  if (path === "/debt-reminders") {
    return userRole === "superadmin" || userRole === "cobranza";
  }

  if (path === "/metas-de-venta") {
    return (
      userRole === "superadmin" || userRole === "admin" || userRole === "seller"
    );
  }

  if (path.startsWith("/cotizaciones")) {
    return userRole === "superadmin";
  }

  if (
    path === "/daily-debt-snapshots" ||
    path.startsWith("/daily-debt-snapshots/")
  ) {
    return (
      userRole === "superadmin" ||
      userRole === "cobranza" ||
      userRole === "facturacion"
    );
  }

  // Contabilidad routes - only superadmin and admin
  if (path.startsWith("/contabilidad/")) {
    return userRole === "superadmin" || userRole === "admin";
  }

  // Purchasing routes - superadmin, admin, logistica, and produccion-admin.
  // (AP suppliers/facturas moved to /contabilidad/* — covered by the block above.)
  if (path.startsWith("/purchasing/")) {
    return (
      userRole === "superadmin" ||
      userRole === "admin" ||
      userRole === "logistica" ||
      userRole === "produccion-admin"
    );
  }

  // Exchange rates route
  if (path === "/exchange-rates") {
    return userRole === "superadmin" || userRole === "admin";
  }

  // Production routes - superadmin, admin, logistica, production (limited), and produccion-admin
  if (path.startsWith("/production/")) {
    // Production role can only access batch list and detail pages
    if (userRole === "production") {
      // Allow /production/batches (list) and /production/batches/:id (detail)
      // Deny /production/batches/new and /production/recipes
      return (
        path === "/production/batches" ||
        (path.startsWith("/production/batches/") &&
          path !== "/production/batches/new")
      );
    }
    return (
      userRole === "superadmin" ||
      userRole === "admin" ||
      userRole === "logistica" ||
      userRole === "produccion-admin"
    );
  }

  // Costing (Costeo) routes - superadmin, admin, logistica (view), produccion-admin
  if (path === "/costeo" || path.startsWith("/costeo/")) {
    return (
      userRole === "superadmin" ||
      userRole === "admin" ||
      userRole === "logistica" ||
      userRole === "produccion-admin"
    );
  }

  // WMS Movements - superadmin only
  if (path === "/wms/movements") {
    return userRole === "superadmin";
  }

  // WMS routes - superadmin, admin, logistica, and bodega
  if (path === "/wms" || path.startsWith("/wms/")) {
    return (
      userRole === "superadmin" ||
      userRole === "admin" ||
      userRole === "logistica" ||
      userRole === "bodega"
    );
  }

  // Totem routes - superadmin and logistica only
  if (path === "/totems" || path.startsWith("/totems/")) {
    return userRole === "superadmin" || userRole === "logistica";
  }

  // New parallel inventory module (beta) - superadmin only during testing
  if (path === "/inventario" || path.startsWith("/inventario/")) {
    return userRole === "superadmin";
  }

  return true;
};
